import { createStructuredSelector } from 'reselect'

import {
  SUPPLIER_DETAIL,
  SUPPLIER_DETAIL_SUCCESS,
  SUPPLIER_DETAIL_ERROR,
  SUPPLIER_ADD_SET,
  SUPPLIER_ADD_CHANGE,
  SUPPLIER_EDIT_MODAL_SET,
  SUPPLIER_ADD_MODAL_SET,
  SUPPLIER_EDIT_TAB_SET,
  SUPPLIER_SEARCH,
  SUPPLIER_SEARCH_SUCCESS,
  SUPPLIER_SEARCH_ERROR,
  SUPPLIER_ADD,
  SUPPLIER_ADD_SUCCESS,
  SUPPLIER_ADD_ERROR,
  SUPPLIER_HEADER,
  SUPPLIER_SEARCH_SUPPLIER_STATE_LIST,
  SUPPLIER_SEARCH_SUPPLIER_STATE_LIST_SUCCESS,
  SUPPLIER_SEARCH_SUPPLIER_STATE_LIST_ERROR,
  SUPPLIER_SEARCH_SUPPLIER_LIST,
  SUPPLIER_SEARCH_SUPPLIER_LIST_SUCCESS,
  SUPPLIER_SEARCH_SUPPLIER_LIST_ERROR,
  SUPPLIER_LIST,
  SUPPLIER_LIST_SUCCESS,
  SUPPLIER_LIST_ERROR,
  SUPPLIER_SEARCH_SET,
  SUPPLIER_SEARCH_CHANGE,
  SUPPLIER_PAGE_SET,
  SUPPLIER_VIEW_MODAL_SET,
  SUPPLIER_VIEW_DETAIL_MODAL_SET,
  SUPPLIER_VIEW_SET,
  SUPPLIER_VIEW_TAB_SET,
  SUPPLIER_EDIT_CHANGE
} from '../actions';

export const NAME = 'supplier';

export const SupplierDetail = (data) => ({
  type: SUPPLIER_DETAIL,
  payload: data
});

export const SupplierDetailSuccess = (data) => ({
  type: SUPPLIER_DETAIL_SUCCESS,
  payload: data
});

export const SupplierDetailError = (error) => ({
  type: SUPPLIER_DETAIL_ERROR,
  payload: error
});

export const SupplierAddSet = (data) => ({
  type: SUPPLIER_ADD_SET,
  payload: data
});

export const SupplierAddChangeSet = (data) => ({
  type: SUPPLIER_ADD_CHANGE,
  payload: data
});

export const SupplierEditModalSet = (data) => ({
  type: SUPPLIER_EDIT_MODAL_SET,
  payload: data
});

export const SupplierAddModalSet = (data) => ({
  type: SUPPLIER_ADD_MODAL_SET,
  payload: data
});

export const SupplierEditTabSet = (data) => ({
  type: SUPPLIER_EDIT_TAB_SET,
  payload: data
});

export const SupplierViewTabSet = (data) => ({
  type: SUPPLIER_VIEW_TAB_SET,
  payload: data
});

export const SupplierSearch = (data) => ({
  type: SUPPLIER_SEARCH,
  payload: data
});

export const SupplierSearchSuccess = (data) => ({
  type: SUPPLIER_SEARCH_SUCCESS,
  payload: data
});

export const SupplierSearchError = (error) => ({
  type: SUPPLIER_SEARCH_ERROR,
  payload: error
});

export const SupplierAdd = (data) => ({
  type: SUPPLIER_ADD,
  payload: data
});

export const SupplierAddSuccess = (data) => ({
  type: SUPPLIER_ADD_SUCCESS,
  payload: data
});

export const SupplierAddError = (error) => ({
  type: SUPPLIER_ADD_ERROR,
  payload: error
});

export const SupplierHeader = (data) => ({
  type: SUPPLIER_HEADER,
  payload: data
});

export const SupplierSearchSupplierStateList = () => ({
  type: SUPPLIER_SEARCH_SUPPLIER_STATE_LIST
});

export const SupplierSearchSupplierStateListSuccess = (message) => ({
  type: SUPPLIER_SEARCH_SUPPLIER_STATE_LIST_SUCCESS,
  payload: message
});

export const SupplierSearchSupplierStateListError = (error) => ({
  type: SUPPLIER_SEARCH_SUPPLIER_STATE_LIST_ERROR,
  payload: error
});

export const SupplierSearchSupplierList = () => ({
  type: SUPPLIER_SEARCH_SUPPLIER_LIST
});

export const SupplierSearchSupplierListSuccess = (message) => ({
  type: SUPPLIER_SEARCH_SUPPLIER_LIST_SUCCESS,
  payload: message
});

export const SupplierSearchSupplierListError = (error) => ({
  type: SUPPLIER_SEARCH_SUPPLIER_LIST_ERROR,
  payload: error
});

export const SupplierList = (page, num_page, orderBy, filters, stateFilter) => ({
  type: SUPPLIER_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const SupplierListSuccess = (data) => ({
  type: SUPPLIER_LIST_SUCCESS,
  payload: data
});

export const SupplierListError = (error) => ({
  type: SUPPLIER_LIST_ERROR,
  payload: error
});

export const SupplierSearchSet = (data) => ({
  type: SUPPLIER_SEARCH_SET,
  payload: data
});

export const SupplierSearchChangeSet = (data) => ({
  type: SUPPLIER_SEARCH_CHANGE,
  payload: data
});

export const SupplierPageSet = (data) => ({
  type: SUPPLIER_PAGE_SET,
  payload: data
});

export const SupplierViewModalSet = (data) => ({
  type: SUPPLIER_VIEW_MODAL_SET,
  payload: data
});

export const SupplierViewDetailModalSet = (data) => ({
  type: SUPPLIER_VIEW_DETAIL_MODAL_SET,
  payload: data
});


export const SupplierViewSet = (data) => ({
  type: SUPPLIER_VIEW_SET,
  payload: data
});

export const SupplierEditChangeSet = (data) => ({
  type: SUPPLIER_EDIT_CHANGE,
  payload: data
});
const supplier = (state) => state[NAME];
export const SupplierSelector = createStructuredSelector({
  supplier
})
